<template>
  <div class="table-section">
    <div class="table-top">
      <b-row>
        <b-col md="4" lg="4" class="my-1">
          <p class="table-filter text-left">
            <BaseInput
              type="text"
              label="Search"
              :inputType="'text'"
              v-model="filter"
              placeholder="Search something..."
              :hasPreIcon="false"
            >
            </BaseInput>
          </p>
        </b-col>
        <b-col md="8" lg="8" class="my-1">
          <p class="table-action text-right">
            <span class="excel-download-btn-hold">
              <button
                type="button"
                class="btn btn-primary btn-semi-rounded mb-2 mr-2"
              >
                <i class="bx bxs-report"></i> &nbsp; &nbsp;
                <download-excel
                  class="excel-download-btn"
                  :data="items"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  name="filename.xls"
                >
                  Download As Excel
                </download-excel>
              </button>
            </span>
          </p>
        </b-col>
      </b-row>
    </div>

    <b-table
      striped
      hover
      :fields="fields"
      :items="items"
      :busy="isBusy"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      sort-icon-left
      responsive="sm"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <!-- A virtual column -->
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(status)="data">
        <p class="name-field">
          <span
            v-if="data.item.status === 'ACTIVE'"
            class="badge badge-pill badge-soft-success font-size-12"
            >{{ data.item.status }}</span
          >
          <span
            v-if="data.item.status !== 'ACTIVE'"
            class="badge badge-pill badge-soft-danger font-size-12"
            >{{ data.item.status }}</span
          >
        </p>
      </template>

      <!--      <template v-slot:cell(action)="data">-->
      <!--        <p class="name-field">-->
      <!--          <span>-->
      <!--            <button-->
      <!--              @click="deleteBatchEntry(data.item)"-->
      <!--              class="btn btn-danger btn-sm mr-1"-->
      <!--              v-b-tooltip.hover.right-->
      <!--              title="Delete Entry"-->
      <!--            >-->
      <!--              <i class="bx bx-trash"></i>-->
      <!--            </button>-->
      <!--          </span>-->
      <!--        </p>-->
      <!--      </template>-->

      <!-- Optional default data cell scoped slot -->
      <template v-slot:cell()="data">
        <i>{{ data.value }}</i>
      </template>
    </b-table>

    <b-row>
      <b-col sm="5" md="4" class="my-1">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            v-model="perPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="8" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StoreUtils from "../../../../utils/BaseUtils/StoreUtils";
import RouterUtils from "../../../../utils/BaseUtils/RouterUtils";
import NotificationUtils from "../../../../utils/BaseUtils/NotificationUtils";

export default {
  name: "AllBatchEntriesTable",
  data() {
    return {
      sortBy: "date",
      sortDesc: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      // Note 'isActive' is left out and will not appear in the rendered table
      fields: [
        // A virtual column that doesn't exist in items
        { key: "index", label: "S/N", sortable: true, class: "text-center" },
        // A column that needs custom formatting
        { key: "accountNumber", label: "Account Number", sortable: true },
        { key: "serialNumber", label: "Serial Number", sortable: true },
        { key: "accountType", label: "Account Type", sortable: true },
        { key: "bankCode", label: "Bank Code", sortable: true },
        { key: "branchCode", label: "Branch Code", sortable: true },
        { key: "checker", label: "Checker", sortable: true },
        { key: "contractType", label: "Contract Type", sortable: true },
        { key: "createdAt", label: "Created At", sortable: true },
        { key: "batchReference", label: "Batch Reference", sortable: true },
        { key: "drCr", label: "DrCr", sortable: true },
        { key: "glCategory", label: "Gl Category", sortable: true },
        { key: "glLevel1Code", label: "Gl Level1 Code", sortable: true },
        { key: "glLevel2Code", label: "Gl Level2 Code", sortable: true },
        { key: "maker", label: "Maker", sortable: true },
        { key: "status", label: "status", sortable: true },
      ],
      json_fields: {
        id: "id",
        serialNumber: "accountNumber",
        accountNumber: "accountNumber",
        accountType: "accountType",
        bankCode: "bankCode",
        branchCode: "branchCode",
        checker: "checker",
        contractType: "contractType",
        createdAt: "createdAt",
        customerId: "customerId",
        drCr: "drCr",
        glCategory: "glCategory",
        glLevel1Code: "glLevel1Code",
        glLevel2Code: "glLevel2Code",
        maker: "maker",
        makerBankCode: "makerBankCode",
        makerBranchCode: "makerBranchCode",
        status: "status",
        message: "message",
        updatedAt: "updatedAt"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],

      currentBatchToDelete: {}
    };
  },
  methods: {
    deleteBatchEntry(entry) {
      let notificationModalBody = {
        type: "warning", //error, success, warning
        mode: "yes-no", // default, yes-no
        title: "Confirmation",
        message: "Are you sure you want to delete this entry?",
        noAction: () => {
          NotificationUtils.closeNotificationModal();
        },
        noActionTitle: "No",
        yesAction: () => {
          StoreUtils.dispatch(
            StoreUtils.actions.journal.DELETE_ENTRY_FROM_CURRENT_BATCH,
            entry.id
          );
          NotificationUtils.closeNotificationModal();
        },
        yesActionTitle: "Yes"
      };

      NotificationUtils.showNotificationModal(notificationModalBody);
    },
    returnItems() {},
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },

  computed: {
    ...mapState({
      items: state => state.journal.currentBatchEntries,
      isBusy: state => state.loader.tableLoader,
      journal: state => state.journal
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.filter = " ";
  },

  created() {
    if (!this.journal.currentBatch.batchReference) {
      NotificationUtils.addNotificationSlide(
        "No Current Batch",
        NotificationUtils.type.ERROR
      );
      RouterUtils.changeRouteTo(RouterUtils.routes.terminal.ALL_BATCHES);
      return;
    }
    StoreUtils.dispatch("terminal/fetchCurrentBatchEntries");
  }
};
</script>

<style scoped>
.view-more-info i {
  font-weight: 600;
}
.view-more-info {
  font-weight: 600;
  margin-right: 3px;
  cursor: pointer;
}
</style>
